export function processFileName(fileName: string): string {
  const replaceReg = /[\s+]/g;
  return fileName.replace(replaceReg, "_");
}

export function processUrl(url: string): string {
  return decodeURIComponent(url);
}

export function getFilename(pth: string): string {
  const pathname = getPathname(pth);
  const basename = pathBasename(pathname);
  const decoded = decodeURIComponent(basename);
  return limitFilename(decoded);
}

export function getPathname(uri: string): string {
  const a = document.createElement("a");
  a.href = uri;
  return a.pathname;
}

export function limitFilename(filename: string, maxLength = 40): string {
  let extname = pathExtname(filename);
  let basename = pathBasename(filename, extname);

  if (!basename) {
    return filename;
  }

  if (basename.length > maxLength) {
    extname = extname.replace(".", "");
    basename = basename.substr(0, maxLength - extname.length - 1) + "…";
  }

  return basename + extname;
}

// ts-jest or jest don't see node "path" module so I've copied this from
// https://github.com/jinder/path/blob/master/path.js
// takes too much time to investigate..
function splitPath(filename: string) {
  const splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^/]+?|)(\.[^./]*|))(?:[/]*)$/;
  const matches = splitPathRe.exec(filename);
  if (!matches) {
    return [];
  }
  return matches.slice(1);
}
const pathExtname = (path: string) => splitPath(path)[3];
const pathBasename = (path: string, ext?: string) => {
  let f = splitPath(path)[2];
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};
